import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/202405/summer-vacation-homework-2024-student/index.vue')
const Paper = () => import('../activity/202405/summer-vacation-homework-2024-student/paper/Paper.vue')
const Record = () => import('../activity/202405/summer-vacation-homework-2024-student/RecordList.vue')

export const indexRoute: RouteConfig = {
  path: '/summer-vacation-2024-homework-stu',
  name: 'summer_vacation_2024_homework_stu',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2024暑假体育作业',
    ignoreLogin: true,
  },
}

export const paperRoute: RouteConfig = {
  path: '/summer-vacation-2024-homework-stu-paper',
  name: 'summer_vacation_2024_homework_stu_paper',
  component: Paper,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '奥运知识大闯关',
    ignoreLogin: true,
  },
}

export const recordRoute: RouteConfig = {
  path: '/summer-vacation-2024-homework-stu-record',
  name: 'summer_vacation_2024_homework_stu_record',
  component: Record,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的奖品',
    ignoreLogin: true,
  },
}

export default [indexRoute, paperRoute, recordRoute]
